import React from 'react';
import styled from '@xstyled/styled-components';
import { AppHeader } from './AppHeader';
import { Head } from './Head';
var StickyHeader = styled.div.withConfig({
  displayName: "PageLayout__StickyHeader",
  componentId: "sc-1dbknlt-0"
})(["position:sticky;top:0;left:0;right:0;z-index:10;"]);
var Main = styled.main.withConfig({
  displayName: "PageLayout__Main",
  componentId: "sc-1dbknlt-1"
})(["background-color:background;flex:1;"]);
var Container = styled.div.withConfig({
  displayName: "PageLayout__Container",
  componentId: "sc-1dbknlt-2"
})(["display:flex;flex-direction:column;min-height:100vh;"]);
export function PageLayout(_ref) {
  var children = _ref.children,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, {
    title: title
  }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(StickyHeader, null, /*#__PURE__*/React.createElement(AppHeader, null)), /*#__PURE__*/React.createElement(Main, {
    id: "main"
  }, children)));
}